// extracted by mini-css-extract-plugin
export default {"wrapper":"Bn-z","response":"Cn-z","error":"Dn-z","disabled":"En-z","buttons":"Fn-z","feedbackQuestionSection":"Gn-z","yesNoWrapper":"Hn-z"};